module.exports = __webpack_public_path__ + "img/ico_order_delivery_negative.84c09d5.png";